// The diary editor's 「今天」.
//
// W54.0 A1 moved this out of `components/diary/DiaryEditor.tsx` with the rest
// of the field state. It is a **local** calendar day: the offset is shifted
// off before the ISO slice, so the answer is the calendar day where the
// person is, not in UTC — a diary dated 「今天」 means today where they are.
//
// `PairInvitePage.tsx` carries a second copy of the same three lines. That is
// left alone: promoting it is a separate change, and this sprint's subject is
// the diary editor's data integrity, not a shared-date-helper refactor.

export function todayISO(): string {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}
